import { Tooltip } from '@mui/material';
import React from 'react';
import colors from './colors';

export type TooltipProps = {
  title: React.ReactNode
  children: React.ReactElement
};

export const TooltipUI: React.FC<TooltipProps> = ({ children, title }) => {
  return (
    <Tooltip
      title={title}
      enterTouchDelay={0}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: colors.chartreuse,
          },
        },
      }}
    >
      <div>{children}</div>
    </Tooltip>
  );
};
